import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import RegularButton from 'components/CustomButtons/Button';
import { LibraryAdd, Remove } from '@material-ui/icons';
import { TextField } from '@material-ui/core';
import ModalFilterArticle from 'components/Tvendo/Common/ModalFilterArticle';
import { wsCreate } from 'services/WService';
import { useNavigate, useParams } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { wsGet } from 'services/WService';
import { wsUpdate } from 'services/WService';

function NewMaterialList() {
  const { id } = useParams();
  const [materialList, setMaterialList] = useState({ from_quantity: 1, to_quantity: 1 });
  const [selectedProduct, setSelectedProduct] = useState(undefined);
  const [selectedProduct2, setSelectedProduct2] = useState(undefined);
  // Modales
  const [openModalProduct, setOpenModalProduct] = useState(false);
  const [openModalProduct2, setOpenModalProduct2] = useState(false);

  const [processing, setProcessing] = useState(false);

  const navigate = useNavigate();

  async function save() {
    if (processing) return;
    let data = {
      from_product_id: selectedProduct.id,
      from_quantity: materialList.from_quantity,
      to_product_id: selectedProduct2.id,
      to_quantity: materialList.to_quantity,
    };

    setProcessing(true);
    let res = await wsCreate('logi/material-list', data);
    setProcessing(false);

    if (res.success) {
      window.alert(res.message);
      navigate(`/admin/inventario/datos-maestros/lista-materiales`);
    } else {
      window.alert(res.message);
    }
  }

  async function update() {
    if (processing) return;
    let data = {
      from_product_id: selectedProduct.id,
      from_quantity: materialList.from_quantity,
      to_product_id: selectedProduct2.id,
      to_quantity: materialList.to_quantity,
    };
    setProcessing(true);
    let res = await wsUpdate('logi/material-list', id, data);
    setProcessing(false);

    if (res.success) {
      window.alert(res.message);
      navigate(`/admin/inventario/datos-maestros/lista-materiales`);
    } else {
      window.alert(res.message);
    }
  }

  async function loadMaterialList() {
    let res = await wsGet('logi/material-list', id);
    if (res.success) {
      console.log(res.data);
      setMaterialList(res.data);
      setSelectedProduct(res.data.from_product);
      setSelectedProduct2(res.data.to_product);
    }
  }

  useEffect(() => {
    if (id !== '0') {
      loadMaterialList();
    }
  }, [id]);

  return (
    <CardContainer title="Nueva lista de materiales">
      <ModalFilterArticle
        open={openModalProduct}
        setOpen={setOpenModalProduct}
        entity={`logi/product`}
        setProductSelect={setSelectedProduct}
      />
      <ModalFilterArticle
        open={openModalProduct2}
        setOpen={setOpenModalProduct2}
        entity={`logi/product`}
        setProductSelect={setSelectedProduct2}
      />
      <GridContainer>
        {/* Producto origen */}
        <GridItem xs={6}>
          <CardContainer icon={null} title="Producto origen">
            {selectedProduct !== undefined && (
              <div>
                <RegularButton
                  round
                  color="danger"
                  size="sm"
                  onClick={() => setSelectedProduct(undefined)}
                >
                  <Remove />
                </RegularButton>
              </div>
            )}
            {selectedProduct === undefined ? (
              <RegularButton color="success" size="lg" onClick={() => setOpenModalProduct(true)}>
                <LibraryAdd /> Seleccionar producto
              </RegularButton>
            ) : (
              <GridContainer>
                <GridItem xs={12}>
                  ({selectedProduct.ItemCode}) {selectedProduct.ItemName}
                </GridItem>
                <GridItem xs={12}>
                  <TextField
                    label="Cantidad"
                    type="number"
                    value={parseInt(materialList.from_quantity || 0)}
                    disabled
                    inputProps={{
                      min: 1,
                    }}
                    onChange={(e) => {
                      let value = e.target.value;
                      setMaterialList((ml) => ({ ...ml, from_quantity: value }));
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
          </CardContainer>
        </GridItem>

        {/* Producto Destino */}
        <GridItem xs={6}>
          <CardContainer icon={null} title="Producto destino">
            {selectedProduct2 !== undefined && (
              <div>
                <RegularButton
                  round
                  color="danger"
                  size="sm"
                  onClick={() => setSelectedProduct2(undefined)}
                >
                  <Remove />
                </RegularButton>
              </div>
            )}
            {selectedProduct2 === undefined ? (
              <RegularButton color="success" size="lg" onClick={() => setOpenModalProduct2(true)}>
                <LibraryAdd /> Seleccionar producto
              </RegularButton>
            ) : (
              <GridContainer>
                <GridItem xs={12}>
                  ({selectedProduct2.ItemCode}) {selectedProduct2.ItemName}
                </GridItem>
                <GridItem xs={12}>
                  <TextField
                    label="Resultado"
                    type="number"
                    value={parseInt(materialList.to_quantity || 0)}
                    inputProps={{
                      min: 1,
                    }}
                    onChange={(e) => {
                      let value = e.target.value;
                      setMaterialList((ml) => ({ ...ml, to_quantity: value }));
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
          </CardContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={10}></GridItem>
        <GridItem xs={2}>
          <AllowedGuard
            permission={ConstantPermissions.LOGI_MATERIAL_LISTS_STORE}
            component={
              <RegularButton
                color="success"
                disabled={
                  processing
                    ? true
                    : selectedProduct === undefined || selectedProduct2 === undefined
                }
                onClick={() => {
                  window.alert('No tiene permisos para realizar esta acción');
                }}
              >
                {id === '0' ? 'Procesar' : 'Actualizar'}
              </RegularButton>
            }
          >
            <RegularButton
              color="success"
              disabled={
                processing ? true : selectedProduct === undefined || selectedProduct2 === undefined
              }
              onClick={() => {
                id === '0' ? save() : update();
              }}
            >
              {id === '0' ? 'Procesar' : 'Actualizar'}
            </RegularButton>
          </AllowedGuard>
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default NewMaterialList;
